/* eslint-disable camelcase */
import englishMessages from 'ra-language-english'

export const i18nEnglish = {
  ...englishMessages,
  resources: {
    conversation: {
      name: 'Conversation |||| Conversations',
      list: 'Conversations',
      edit: 'Edit conversation',
      fields: {
        channel: 'Channel',
        status: 'Status',
        subject: 'Subject',
        contact_name: 'Contact',
        employee_email: 'Employee',
        created: 'Created',
        notes: 'Notes',
      },
    },
    employees: {
      list: 'Employees',
      show: {
        title: 'Employee Details',
        calls: 'Assigned Calls',
        noCalls: 'No calls.',
      },
    },
  },
}
